import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../boot";

export const getCustomerList = createAsyncThunk('utils/customer-list', async (payload) => {
  try {
    const response = await axios.get(`${baseUrl}vancouverapis/utils/api/v1/customer-list`, { payload })
    return response
  } catch (error) {
    throw error;
  }
}
);
